import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { EditableArea, EditableComponent, RefService } from "@magnolia/react-editor";
import { getMagnoliaContext } from "../../../magnolia.service";
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";

// Uses alternative approach and directly instantiates Swiper instance to create the right swiper html structure (EditableArea is interfering with that)

const ItemsArea = ({ content }) => {
    return (
        <>
            {content["@nodes"].map((nodeName, idx) => (
                <div className="swiper-slide" key={idx}>
                    <EditableComponent key={idx} content={content[nodeName]} />
                </div>
            ))}
        </>
    );
};

const Hero = (props) => {
    const location = useLocation();
    const magnoliaContext = getMagnoliaContext(location);
    const { items } = props;
    const slideCount = items?.["@nodes"]?.length ?? 0;
    const swiperRef = useRef(null);
    const swiperInstance = useRef(null);

    useEffect(() => {
        if (!swiperRef.current) return;

        swiperInstance.current = new Swiper(swiperRef.current, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],
            effect: "fade",
            loop: slideCount > 1,
            allowTouchMove: !magnoliaContext?.isMagnolia,
            speed: 1000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        return () => {
            if (swiperInstance.current) {
                swiperInstance.current.destroy(true, true);
                swiperInstance.current = null;
            }
        };
    }, []);

    return (
        <div className="slider-area">
            <div className="slider-active nav-style-1">
                <div className="swiper" ref={swiperRef}>
                    <EditableArea content={items} className="swiper-wrapper" customView={ItemsArea} />

                    {/* Custom Navigation Buttons */}
                    <button className="swiper-button-prev ht-swiper-button-nav">
                        <i className="pe-7s-angle-left" />
                    </button>
                    <button className="swiper-button-next ht-swiper-button-nav">
                        <i className="pe-7s-angle-right" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Hero;
